import Axios from 'axios';
import { empresasLead } from './bff/bffClient';
import { mapCaucionLead } from './bff/bffMappers';
import { getPathName, getPais, getApiHash, getApiToken } from './helper';

/**
 * Lead Caución. ROUTING POR PAÍS (el BFF es Argentina-only):
 * - AR: body tipado §12.2 (`mapCaucionLead`) al BFF. Caución es rubro "ambos":
 *   personType se deriva del tipoDoc (CUIT->LEGAL, DNI->PHYSICAL).
 * - UY: flujo LEGACY al monolito (POST {monolito}/SetCotizacionCaucionJSON).
 * El país lo determina `getPais()`; el call-site puede forzarlo con `pais`.
 * Devuelve el envelope { data: { api_status, api_data } }.
 */
const guardarContactoCaucion = async (origen, tipoCotizador, landingUrl, refererUrl, nombre, apellido, codigoArea, telefono, email, tipoDoc, cuit, razonSocial, provincia, localidad, tipoCobertura, moneda, sumaAsegurada, captchaToken, pais = getPais()) => {
    if (pais === 'UY') {
        const params = {
            hash: await getApiHash(),
            isMobile: "false",
            rubro: "CAUCION",
            origen: origen,
            tipoCotizador: tipoCotizador,
            landingUrl: landingUrl,
            refererUrl: refererUrl,
            cuit: cuit,
            razonSocial: razonSocial,
            nombre: nombre,
            apellido: apellido,
            email: email,
            tipoDocumento: (tipoDoc || "").toLocaleUpperCase(),
            numeroDocumento: cuit,
            codigoArea: codigoArea,
            telefono: telefono,
            tipoCobertura: tipoCobertura,
            moneda: moneda,
            sumaAsegurada: sumaAsegurada,
            provincia: provincia,
            localidad: localidad,
            g_recaptcha_response: captchaToken,
        };
        const headers = {
            'content-type': 'application/json',
            "Authorization": 'Bearer ' + await getApiToken(),
        };
        return await Axios.post(await getPathName() + "/SetCotizacionCaucionJSON", params, { headers })
            .then((response) => response)
            .catch((error) => error);
    }

    const body = mapCaucionLead({
        origen,
        tipoCotizador,
        landingUrl: landingUrl ?? (typeof window !== 'undefined' ? window.location.href : undefined),
        refererUrl,
        nombre,
        apellido,
        codigoArea,
        telefono,
        email,
        tipoDoc,
        cuit,
        razonSocial,
        provincia,
        localidad,
        tipoCobertura,
        moneda,
        sumaAsegurada,
    });

    try {
        const apiData = await empresasLead(body);
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        return error;
    }
};

export default guardarContactoCaucion;
